import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import AllHeader from "../components/AllHeader";


function Ads() {
  return (
    <div className="rgc-pages">
      <AllHeader>
        <span>تبلیغات شهری</span>
      </AllHeader>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center rgc-title">
          <h3>تبلیغات شهری</h3>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default Ads;
